import React from 'react';
import { CheckCircle2, AlertTriangle, HelpCircle, XCircle, Clock, MapPinOff } from 'lucide-react';

export const FACE = {
  match: { label: 'Match', cls: 'bg-emerald-100 text-emerald-800 border-emerald-300', Icon: CheckCircle2 },
  check: { label: 'Check', cls: 'bg-amber-100 text-amber-800 border-amber-300', Icon: AlertTriangle },
  no_ref: { label: 'No reference', cls: 'bg-gray-100 text-gray-600 border-gray-300', Icon: HelpCircle },
};

export const STATUS = {
  pending: { label: 'Pending', cls: 'bg-amber-100 text-amber-800', Icon: Clock },
  approved: { label: 'Approved', cls: 'bg-emerald-100 text-emerald-800', Icon: CheckCircle2 },
  rejected: { label: 'Rejected', cls: 'bg-red-100 text-red-700', Icon: XCircle },
};

export const DAY = {
  checked_out: { label: 'Checked out', cls: 'bg-emerald-100 text-emerald-800' },
  on_duty: { label: 'On duty', cls: 'bg-sky-100 text-sky-800' },
  pending: { label: 'Pending', cls: 'bg-amber-100 text-amber-800' },
  rejected: { label: 'Rejected', cls: 'bg-red-100 text-red-700' },
  missed_checkout: { label: 'Missed check-out', cls: 'bg-orange-100 text-orange-800' },
  auto_closed: { label: 'Auto-closed', cls: 'bg-violet-100 text-violet-800' },
  contact_hr: { label: 'Contact HR', cls: 'bg-red-100 text-red-700' },
  absent: { label: 'Absent', cls: 'bg-gray-100 text-gray-500' },
};

export const FaceBadge = ({ result, score, testId }) => {
  const f = FACE[result] || FACE.no_ref;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-semibold ${f.cls}`} data-testid={testId}>
      <f.Icon className="w-3.5 h-3.5" />{f.label}{score != null && <span className="font-mono opacity-70">{Math.round(score * 100)}%</span>}
    </span>
  );
};

export const StatusBadge = ({ status, testId }) => {
  const s = STATUS[status] || STATUS.pending;
  return <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold ${s.cls}`} data-testid={testId}><s.Icon className="w-3.5 h-3.5" />{s.label}</span>;
};

/** Late / Left early / Off-site chips for one punch (fields from the API punch_flags + on_site). */
export const FlagBadges = ({ p, testId }) => {
  if (!p) return null;
  const chip = 'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold';
  return (
    <>
      {p.late_min ? <span className={`${chip} bg-rose-100 text-rose-700`} data-testid={`${testId}-late`}><Clock className="w-3 h-3" />Late {p.late_min}m</span> : null}
      {p.early_min ? <span className={`${chip} bg-yellow-100 text-yellow-800`} data-testid={`${testId}-early`}><Clock className="w-3 h-3" />Left early {p.early_min}m</span> : null}
      {p.on_site === false ? <span className={`${chip} bg-slate-800 text-white`} data-testid={`${testId}-offsite`}><MapPinOff className="w-3 h-3" />Off-site</span> : null}
    </>
  );
};

export const DayBadge = ({ status, testId }) => {
  const s = DAY[status] || DAY.absent;
  return <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-semibold ${s.cls}`} data-testid={testId}>{s.label}</span>;
};
